export const formatCurrency = function (value, divisor, region) {
  const converted = value / divisor;
  let formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: region || "USD",
    });
  return formatter.format(converted); /* $2,500.00 */
};
